import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 52,
	height: 52,
	viewBox: "0 0 52 52",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M25.9367 0C11.5992 0 0 11.5992 0 25.9367C0 40.2742 11.5992 51.8734 25.9367 51.8734C40.2742 51.8734 51.8734 40.2742 51.8734 25.9367C51.8734 11.5992 40.2484 0 25.9367 0ZM35.8567 27.1767L19.995 36.3475C19.1167 36.8642 18.0059 36.2184 18.0059 35.2109V16.895C18.0059 15.8875 19.1167 15.2417 19.995 15.7584L35.8567 24.9292C36.735 25.4459 36.735 26.7117 35.8567 27.2284V27.1767Z",
		fill: "white"
	})
});
export default SvgPlayIcon;
